export const SET_REMOVED_COLLABORATOR_ERROR = 'SET_REMOVED_COLLABORATOR_ERROR';
